import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.7 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.58 9.05H4.11c-.17 0-.3.13-.3.3s.13.3.3.3h5.47c.17 0 .3-.13.3-.3s-.13-.3-.3-.3zm0 1.95H4.11c-.17 0-.3.13-.3.3s.13.3.3.3h5.47c.17 0 .3-.13.3-.3s-.13-.3-.3-.3zM4.11 7.64h2.47c.17 0 .3-.13.3-.3s-.13-.3-.3-.3H4.11c-.17 0-.3.13-.3.3s.14.3.3.3z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.61 4.92 9.06 1.47a.304.304 0 0 0-.21-.08H1.71c-.39 0-.71.32-.71.71v12.85c0 .39.32.71.71.71h10.27c.39 0 .71-.32.71-.71V5.13a.265.265 0 0 0-.08-.21zm-.51.38H9.27c-.06 0-.11-.05-.11-.11V2.4l2.94 2.86v.04zm-.12 9.76H1.71c-.06 0-.11-.05-.11-.11V2.1c0-.06.05-.11.11-.11h6.84v3.2c0 .39.32.71.71.71h2.83v9.04c.01.07-.04.12-.11.12z"
    }, null, -1)
  ])))
}
export default { render };